'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQueryClient } from '@repo/tanstack/query';
import { type CompanyListFilter, DEFAULT_COMPANIES_LIST_INPUT } from './use-suspense-fetch-companies.tsx';

// Prefetches the first page of a Company list as it opens from the sidebar.
export const usePrefetchFirstCompaniesPage = filter => {
  const $ = _c(4);
  const api = useApi();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== api.companies.listByType || $[1] !== filter || $[2] !== queryClient) {
    t0 = () => {
      queryClient.prefetchQuery(api.companies.listByType.queryOptions({
        input: DEFAULT_COMPANIES_LIST_INPUT,
        path: {
          filter
        }
      }));
    };
    $[0] = api.companies.listByType;
    $[1] = filter;
    $[2] = queryClient;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};